import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import MarketplaceFilter, { MarketplaceBadge } from '../components/MarketplaceFilter';

export default function MvpUnitEconomics({ clientId }) {
  const [mp, setMp] = useState('all');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const marketplace = mp === 'all' ? undefined : mp;
    apiClient
      .get('/mvp/unit-economics', { params: { client_id: clientId, marketplace } })
      .then(({ data }) => { if (!cancelled) setItems(data?.items || []); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clientId, mp]);

  const fmt = (v) => (v != null ? Number(v).toLocaleString('ru-RU', { maximumFractionDigits: 0 }) : '—');

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-xl font-bold">Юнит-экономика</h2>
        <MarketplaceFilter value={mp} onChange={setMp} available={['wb', 'ozon']} />
      </div>
      {loading ? (
        <p className="text-[var(--wb-text-muted)]">Загрузка…</p>
      ) : (
        <div className="wb-card overflow-hidden max-h-[70vh] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--wb-surface-muted)] sticky top-0">
              <tr>
                <th className="p-2 text-left">МП</th>
                <th className="p-2">Дата</th>
                <th className="p-2">SKU</th>
                <th className="p-2">Выручка</th>
                <th className="p-2">Реклама</th>
                <th className="p-2">Прибыль</th>
                <th className="p-2">Маржа</th>
                <th className="p-2">ДРР</th>
              </tr>
            </thead>
            <tbody>
              {items.slice(0, 100).map((row, i) => (
                <tr key={i} className="border-t border-[var(--wb-border)]">
                  <td className="p-2"><MarketplaceBadge marketplace={row.marketplace} /></td>
                  <td className="p-2">{row.period_date}</td>
                  <td className="p-2 font-mono text-xs">{row.sku}</td>
                  <td className="p-2">{fmt(row.revenue)}</td>
                  <td className="p-2">{fmt(row.ad_spend)}</td>
                  <td className="p-2">{fmt(row.profit)}</td>
                  <td className="p-2">{row.margin_pct != null ? `${Number(row.margin_pct).toFixed(1)}%` : '—'}</td>
                  <td className="p-2">{row.drr_pct != null ? `${Number(row.drr_pct).toFixed(1)}%` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
